import Axios from "../utils/axiosInstance";
import qs from "qs";

const cometChatAppId = process.env.REACT_APP_COMETCHAT_APP_ID; // Get from environment variables
const cometChatApiKey = process.env.REACT_APP_COMETCHAT_API_KEY;

const getHostEventDetails = (params: {}) => {
  return Axios.get(
    `getHostEventDetails${params ? "?" + qs.stringify(params) : ""}`
  );
};

const getGuestEventDetails = (params: {}) => {
  return Axios.get(
    `getGuestEventDetails${params ? "?" + qs.stringify(params) : ""}`
  );
};

const getGuestList = (params: {}) => {
  return Axios.get(`getGuestLists${params ? "?" + qs.stringify(params) : ""}`);
};

const updateEventJoiningStatus = (data: any) => {
  return Axios.post("updateEventJoiningStatus", data);
};

const updateEvent = (data: any) => {
  return Axios.put("updateEvent", data);
};

const deleteEvent = (data: any) => {
  return Axios.post("event/requestCancelEventEmail", data);
};

const getGuestDetails = (params: {}) => {
  return Axios.get(`getUserProfile${params ? "?" + qs.stringify(params) : ""}`);
};

const likeEventUserProfile = (data: any) => {
  return Axios.post("likeEventUserProfile", data);
};

const publishEvent = (data: any) => {
  return Axios.put("event/publish", data);
};

const reportUser = (data: any) => {
  return Axios.post("reportProfile", data);
};

const unInviteUser = (data: any) => {
  return Axios.post("events/uninviteUser", data);
};

const matchInCometChat = (userId: number, friendId: number) => {
  const headers = {
    apiKey: cometChatApiKey,
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
  };

  const data = {
    accepted: [friendId],
  };

  return Axios.post(
    `https://${cometChatAppId}.api-us.cometchat.io/v3/users/${userId}/friends`,
    data,
    { headers }
  );
};

const unMatchInCometChat = (userId: number, friendId: number) => {
  // Get from environment variables

  const headers = {
    apiKey: cometChatApiKey,
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
  };

  const data = {
    friends: [friendId],
  };

  return Axios.delete(
    `https://${cometChatAppId}.api-us.cometchat.io/v3/users/${userId}/friends`,
    {
      headers: headers,
      data: data, // For DELETE requests, the body needs to be sent in the 'data' property
    }
  );
};

const deleteConversationFromCometChat = (userId: number, friendId: string) => {
  const headers = {
    apiKey: cometChatApiKey,
    "Content-Type": "application/json; charset=UTF-8",
    Accept: "application/json",
  };

  const data = {
    conversationWith: friendId,
    deleteMessagesPermanently: true,
  };

  return Axios.delete(
    `https://${cometChatAppId}.api-us.cometchat.io/v3/users/${userId}/conversation`,
    {
      headers: headers,
      data: data,
    }
  );
};

const getAttendingUsersList = (params: {}) => {
  return Axios.get(
    `getAttendingUsersList${params ? "?" + qs.stringify(params) : ""}`
  );
};

const markAsAttented = (data: any) => {
  return Axios.post("markAsAttented", data);
};

const unMarkAsAttented = (data: any) => {
  return Axios.post("UnMarkAsAttented", data);
};

const getRestrictedGuestStatus = (params: {}) => {
  return Axios.get(
    `users/getRestrictedStatus${params ? "?" + qs.stringify(params) : ""}`
  );
};

const getEventGuestList = (params: {}) => {
  return Axios.get(
    `getEventGuestList${params ? "?" + qs.stringify(params) : ""}`
  );
};

const subscribeToHost = (data: any) => {
  return Axios.post("subscribe-to-host", data);
};

const unSubscribeHost = (data: any) => {
  return Axios.post("unsubscribe-from-host", data);
};

const getHostSubscribedUsers = (params: {}) => {
  return Axios.get(
    `hostSubscribedUsers${params ? "?" + qs.stringify(params) : ""}`
  );
};


const exportGuestListFile = (params: {}) => {
  return Axios.get(
    `exportEventGuests${params ? "?" + qs.stringify(params) : ""}`,
    {
      responseType: "blob",
    }
  );
};

const deleteOrCancelEvent = (data: any) => {
  return Axios.post("event/event-cancel-autoapproval", data);
};

const eventPayoutList = (params: {}) => {
    return Axios.get(
    `events-payouts${params ? "?" + qs.stringify(params) : ""}`
  );
}


const exportEventsCSV = (params: {}) => {
  return Axios.get(
    `export/export-events`,
    {
      responseType: "blob",
    }
  );
}



export const eventPanelService = {
  getHostEventDetails,
  getGuestEventDetails,
  getGuestList,
  updateEventJoiningStatus,
  updateEvent,
  deleteEvent,
  getGuestDetails,
  likeEventUserProfile,
  publishEvent,
  reportUser,
  matchInCometChat,
  unMatchInCometChat,
  deleteConversationFromCometChat,
  unInviteUser,
  getAttendingUsersList,
  markAsAttented,
  unMarkAsAttented,
  getRestrictedGuestStatus,
  getEventGuestList,
  subscribeToHost,
  unSubscribeHost,
  getHostSubscribedUsers,
  exportGuestListFile,
  deleteOrCancelEvent,
  eventPayoutList,
  exportEventsCSV
,};